// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
/* ant button overrides */
.index-module__button-gradiant__ri3yt {
  background: var(--app-primary-color);
  color: #ffffff;
  font: normal normal medium;
  border-radius: 6px;
  border: 1px solid var(--app-primary-color);
  transition: all 0.2s ease-in-out;
  min-width: 143px;
  height: 42px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  text-align: center;
}
.index-module__button-gradiant__ri3yt:focus {
  color: #ffffff !important;
  border: 1px solid var(--app-primary-color);
  background: var(--app-primary-color) !important;
}
.index-module__button-gradiant__ri3yt:hover {
  color: var(--app-primary-color) !important;
  border: 1px solid var(--app-primary-color);
  background: #ffffff !important;
}
.index-module__button-m01__KBi38 {
  margin: 0rem 1rem;
}
@media only screen and (min-width: 600px) and (max-width: 1200px) {
  .index-module__button-gradiant__ri3yt {
    height: 37px;
    min-width: 6rem !important;
    font-size: 12px;
  }
}
/* small mobile */
@media only screen and (min-width: 300px) and (max-width: 600px) {
  .index-module__button-gradiant__ri3yt {
    height: 37px;
    min-width: 6rem !important;
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CustomButton/index.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA,yBAAyB;AACzB;EACE,oCAAoC;EACpC,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,+CAA+C;AACjD;AACA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,YAAY;IACZ,0BAA0B;IAC1B,eAAe;EACjB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,YAAY;IACZ,0BAA0B;IAC1B,eAAe;EACjB;AACF","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n/* ant button overrides */\n.button-gradiant {\n  background: var(--app-primary-color);\n  color: #ffffff;\n  font: normal normal medium;\n  border-radius: 6px;\n  border: 1px solid var(--app-primary-color);\n  transition: all 0.2s ease-in-out;\n  min-width: 143px;\n  height: 42px;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 100%;\n  text-align: center;\n}\n.button-gradiant:focus {\n  color: #ffffff !important;\n  border: 1px solid var(--app-primary-color);\n  background: var(--app-primary-color) !important;\n}\n.button-gradiant:hover {\n  color: var(--app-primary-color) !important;\n  border: 1px solid var(--app-primary-color);\n  background: #ffffff !important;\n}\n.button-m01 {\n  margin: 0rem 1rem;\n}\n@media only screen and (min-width: 600px) and (max-width: 1200px) {\n  .button-gradiant {\n    height: 37px;\n    min-width: 6rem !important;\n    font-size: 12px;\n  }\n}\n/* small mobile */\n@media only screen and (min-width: 300px) and (max-width: 600px) {\n  .button-gradiant {\n    height: 37px;\n    min-width: 6rem !important;\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button-gradiant": `index-module__button-gradiant__ri3yt`,
	"button-m01": `index-module__button-m01__KBi38`
};
export default ___CSS_LOADER_EXPORT___;
